import { HStack, Input, Text, VStack, Flex } from "@chakra-ui/react";
import { ru } from "date-fns/locale";
import { observer } from "mobx-react-lite";
import DatePicker from "react-datepicker";
import { useStores } from "../store/store_context";

const SelectDateMonth = observer(() => {
  const { pageStore } = useStores();

  const formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}-01`;
  };

  return (
    <VStack padding={"10px"} width={"100%"}>
      <Flex
        direction={{ base: "column", md: "row" }} // В колонку на мобильных, в ряд на ПК
        align="center"
        gap={2}
        width="100%"
        justify="center"
      >
        <DatePicker
          selected={pageStore.start_date_month}
          onChange={(date) => {
            if (date) {
              pageStore.updateStartDateMonth(formatLocalDate(date));
              pageStore.updateStartDateDay("");
              pageStore.updateEndDateDay("");
              pageStore.updateEndDateYear("");
              pageStore.updateStartDateYear("");
            }
          }}
          dateFormat="MM.yyyy"
          showMonthYearPicker
          locale={ru}
          placeholderText="выберете месяц начала"
          customInput={
            <Input
              style={{
                width: "255px",
                border: "none",
                background: "#333",
                color: "#EEEEEE",
                borderRadius: "10px",
                fontWeight: 600,
              }}
            />
          }
        />
        <Text fontWeight={"600"} color={"myColor.white"}>
          —
        </Text>
        <DatePicker
          selected={pageStore.end_date_month}
          onChange={(date) => {
            if (date) {
              const year = date.getFullYear();
              const month = date.getMonth();
              const lastDay = new Date(year, month + 1, 0);
              pageStore.updateEndDateMonth(lastDay);
              pageStore.updateStartDateDay("");
              pageStore.updateEndDateDay("");
              pageStore.updateEndDateYear("");
              pageStore.updateStartDateYear("");
            }
          }}
          dateFormat="MM.yyyy"
          showMonthYearPicker
          locale={ru}
          placeholderText="выберете месяц конца"
          customInput={
            <Input
              style={{
                width: "255px",
                border: "none",
                background: "#333",
                color: "#EEEEEE",
                borderRadius: "10px",
                fontWeight: 600,
              }}
            />
          }
        />
      </Flex>
    </VStack>
  );
});

export default SelectDateMonth;